import { takeEvery, select, call, put } from 'redux-saga/effects'

import { makeRequest } from './makeRequest'
import { offline } from 'store/entities/offline/actions'
import { lastAction } from 'store/entities/offline/selectors'

export function* shiftFirst() {
  const action = yield select(lastAction)
  if (action) {
    yield call(makeRequest, action)
    yield put(offline.shiftFirst())
  }
}

export default function* shiftFirstEvery() {
  yield takeEvery(offline.shiftFirst.toString(), shiftFirst)
}
